// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Info from "@sc/XDL/Icons/Info";
import { xBaseTheme } from "@sc/XDL/types";
import { color } from "@sc/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,

        extendedStyles: {
            tooltipContent: {
                css: css`
                    background-color: ${color("common.ui9")};
                    max-width: 256px;
                    border-radius: 4px;
                    min-width: 140px;
                    padding: 12px;
                `,
            },
            triggerWrapper: {
                css: css`
                    height: fit-content;
                    width: fit-content;
                    margin-left: 5px;
                    display: inline-flex;
                    vertical-align: middle;
                `,
            },
        },
        iconProps: {
            src: Info,
            size: 16,
            color: "info.main",
            css: css``,
        },
        typographyProps: {
            size: 14,
            weight: "normal",
            color: "common.ui1",
            css: css`
                line-height: 22px;
                text-align: left;
                letter-spacing: 0;
                white-space: break-spaces;
                word-break: break-word;
                &:hover {
                    text-decoration: none;
                }
            `,
        },
    },
} as xBaseTheme["tooltip"];
